import React from 'react'
import styled from 'styled-components'
import { Text } from 'lib/Text'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #e8e8e8;
  column-gap: 16px;

  :first-child {
    border-top: 1px solid #e8e8e8;
  }
`

const Title = styled(Text)`
  white-space: nowrap;
`

const Property = styled(Text)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  text-align: end;
`

interface Props {
  title: string
  properties?: string[]
  children?: React.ReactNode
  childrenAsProperty?: boolean
  className?: string
}
export const PropertiesList = ({ title, properties = [], children, childrenAsProperty = true, className }: Props) => {
  if (properties.length === 0 && !children) {
    return null
  }

  return (
    <Container className={className}>
      <Title weight="semi" size="ps" color="neutral-60">
        {title}
      </Title>
      {childrenAsProperty ? (
        <Property as="div" weight="regular" size="ps" color="neutral-60">
          {properties.join(', ')}
          {children}
        </Property>
      ) : (
        children
      )}
    </Container>
  )
}
